import { render, staticRenderFns } from "./RandomImg.vue?vue&type=template&id=25e650b6&"
import script from "./RandomImg.vue?vue&type=script&lang=ts&"
export * from "./RandomImg.vue?vue&type=script&lang=ts&"
import style0 from "./RandomImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports